import { useEffect, useState } from "react";
import { weddingConfig } from "../config/weddingConfig";

const pad = (n) => String(n).padStart(2, "0");

// Live countdown to the wedding ceremony (target set in weddingConfig).
export const Countdown = () => {
  const target = new Date(weddingConfig.hero.countdownTarget).getTime();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const diff = Math.max(0, target - now);
  const units = [
    ["Days", Math.floor(diff / 86400000)],
    ["Hours", Math.floor(diff / 3600000) % 24],
    ["Minutes", Math.floor(diff / 60000) % 60],
    ["Seconds", Math.floor(diff / 1000) % 60],
  ];

  return (
    <div
      data-testid="countdown-timer"
      className="mt-4 flex items-start justify-center gap-3.5 sm:gap-5"
    >
      {units.map(([label, value], i) => (
        <div key={label} className="flex items-start gap-3.5 sm:gap-5">
          <div className="flex w-14 flex-col items-center">
            <span className="font-serif text-3xl tabular-nums text-gold-bright sm:text-4xl">
              {pad(value)}
            </span>
            <span className="mt-1.5 font-sans text-[8px] uppercase tracking-[0.3em] text-cream/60">
              {label}
            </span>
          </div>
          {i < units.length - 1 && (
            <span
              aria-hidden="true"
              className="mt-3 h-1 w-1 rotate-45 bg-gold/50"
            />
          )}
        </div>
      ))}
    </div>
  );
};
